function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.flat.js";
import "core-js/modules/es.array.unscopables.flat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import { useEducationLevels } from "../../data/educationLevels";
var programLevelFamiliesMap = {
  '1': 'primary',
  '2': 'secondary',
  '3': 'undergraduate',
  '4': 'postgraduate',
  '5': 'esl'
};
export function useRPSearchParams() {
  var _useEducationLevels = useEducationLevels(),
    educationLevelKeysByFamily = _useEducationLevels.educationLevelKeysByFamily;
  var convertAnswersToSearchParams = function convertAnswersToSearchParams(answers) {
    var _answers$countries, _answers$fieldsOfEduc, _answers$intakes, _answers$programLevel;
    var params = {};
    if (answers.duolingoScore) {
      var duolingo = {
        'filter[english_score][type]': 'duolingo_english',
        'filter[english_score][total]': answers.duolingoScore.total.toString()
      };
      params = _objectSpread(_objectSpread({}, params), duolingo);
    } else if (answers.ieltsScore) {
      var ielts = {
        'filter[english_score][type]': 'ielts',
        'filter[english_score][l]': answers.ieltsScore.listening.toString(),
        'filter[english_score][r]': answers.ieltsScore.reading.toString(),
        'filter[english_score][s]': answers.ieltsScore.speaking.toString(),
        'filter[english_score][w]': answers.ieltsScore.writing.toString()
      };
      params = _objectSpread(_objectSpread({}, params), ielts);
    } else if (answers.pteScore) {
      var pte = {
        'filter[english_score][type]': 'pte',
        'filter[english_score][l]': answers.pteScore.listening.toString(),
        'filter[english_score][r]': answers.pteScore.reading.toString(),
        'filter[english_score][s]': answers.pteScore.speaking.toString(),
        'filter[english_score][w]': answers.pteScore.writing.toString(),
        'filter[english_score][total]': answers.pteScore.total.toString()
      };
      params = _objectSpread(_objectSpread({}, params), pte);
    } else if (answers.toeflScore) {
      var toefl = {
        'filter[english_score][type]': 'toefl',
        'filter[english_score][l]': answers.toeflScore.listening.toString(),
        'filter[english_score][r]': answers.toeflScore.reading.toString(),
        'filter[english_score][s]': answers.toeflScore.speaking.toString(),
        'filter[english_score][w]': answers.toeflScore.writing.toString()
      };
      params = _objectSpread(_objectSpread({}, params), toefl);
    } else if (answers.noEnglishScore) {
      var noEnglishScore = {
        'filter[english_score][type]': 'no_test',
        'filter[english_score][no_test]': answers.noEnglishScore.value
      };
      params = _objectSpread(_objectSpread({}, params), noEnglishScore);
    }
    if ((_answers$countries = answers.countries) !== null && _answers$countries !== void 0 && _answers$countries.length) {
      params['filter[locations]'] = answers.countries.map(function (country) {
        return country.toLowerCase();
      }).join(',');
    }
    if ((_answers$fieldsOfEduc = answers.fieldsOfEducation) !== null && _answers$fieldsOfEduc !== void 0 && _answers$fieldsOfEduc.length) {
      params['filter[disciplines]'] = answers.fieldsOfEducation.join(',');
    }
    if ((_answers$intakes = answers.intakes) !== null && _answers$intakes !== void 0 && _answers$intakes.length) {
      params['filter[intakes]'] = answers.intakes.join(',');
    }
    if ((_answers$programLevel = answers.programLevelFamilies) !== null && _answers$programLevel !== void 0 && _answers$programLevel.length) {
      var educationLevels = answers.programLevelFamilies.map(function (familyId) {
        return programLevelFamiliesMap[familyId];
      }).map(function (familyKey) {
        return educationLevelKeysByFamily[familyKey];
      }).filter(Boolean).flat();
      params['filter[program_levels]'] = educationLevels.join();
    }
    return new URLSearchParams(params).toString();
  };
  return {
    convertAnswersToSearchParams: convertAnswersToSearchParams
  };
}